import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import styles from './Header.module.css';

export const Header: React.FC = () => {
  const { user, isSignedIn } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo} onClick={closeMobileMenu}>
          Process Optimizer
        </Link>
        
        {/* Mobile Menu Toggle */}
        <button 
          className={styles.mobileMenuToggle}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Navigation - Desktop and Mobile */}
        <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
          {isSignedIn && user ? (
            <div className={styles.userMenu}>
              <span className={styles.userName}>{user.fullName}</span>
              <UserButton 
                appearance={{
                  elements: {
                    avatarBox: 'w-8 h-8',
                    userButtonPopoverCard: 'shadow-lg border border-gray-200',
                    userButtonPopoverActionButton: 'hover:bg-gray-50',
                    userButtonPopoverActionButtonText: 'text-gray-700'
                  }
                }}
                afterSignOutUrl="/login"
              />
            </div>
          ) : (
            <div className={styles.authMenu}>
              <Link to="/login" className={styles.authLink} onClick={closeMobileMenu}>
                <span>Login</span>
              </Link>
              <Link to="/register" className={styles.authLink} onClick={closeMobileMenu}>
                <span>Register</span>
              </Link>
            </div>
          )}
        </nav>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div 
            className={styles.mobileOverlay}
            onClick={closeMobileMenu}
            aria-hidden="true"
          />
        )}
      </div>
    </header>
  );
};
